export default __webpack_public_path__ + "static/media/por7o.57b33cc8.jpg";